import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'MapPin',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M21 9.43C21 16.63 12 24 12 24S3 16.63 3 9.43C3 4.11 6.96 0 12 0s9 4.11 9 9.43z" }
      })]
    );
  }
};